export default "__VITE_ASSET__DWJMeCC5__"